// extracted by mini-css-extract-plugin
export default {"tableRow":"TableRow_tableRow__Nf9YW","rowItem":"TableRow_rowItem__6ikUo"};